import React, { useRef, useState, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Box, Button, Typography } from '@mui/material';
import { Clear, Check } from '@mui/icons-material';

const SignaturePad = ({ value, onChange, label = 'Unterschrift', disabled = false }) => {
  const sigRef = useRef(null);
  const containerRef = useRef(null);
  const [confirmed, setConfirmed] = useState(!!value);
  const [canvasWidth, setCanvasWidth] = useState(320);

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setCanvasWidth(containerRef.current.offsetWidth - 4); // 4px for border
      }
    };
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  useEffect(() => {
    if (value && sigRef.current) {
      setConfirmed(true);
    }
  }, [value]);

  const handleClear = () => {
    if (sigRef.current) sigRef.current.clear();
    setConfirmed(false);
    onChange(null);
  };

  const handleConfirm = () => {
    if (sigRef.current && !sigRef.current.isEmpty()) {
      const dataUrl = sigRef.current.toDataURL('image/png');
      setConfirmed(true);
      onChange(dataUrl);
    }
  };

  if (disabled && value) {
    return (
      <Box sx={{ mt: 1 }}>
        <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>{label}</Typography>
        <img src={value} alt="Unterschrift" style={{ maxWidth: '100%', maxHeight: 120, border: '1px solid #e0e0e0', borderRadius: 4, background: '#fff' }} />
      </Box>
    );
  }

  if (confirmed && value) {
    return (
      <Box sx={{ mt: 1 }}>
        <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>{label}</Typography>
        <img src={value} alt="Unterschrift" style={{ maxWidth: '100%', maxHeight: 120, border: '1px solid #e0e0e0', borderRadius: 4, background: '#fff' }} />
        <Box sx={{ mt: 0.5 }}>
          <Button size="small" color="error" startIcon={<Clear />} onClick={handleClear}>
            Neu unterschreiben
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box ref={containerRef} sx={{ mt: 1 }}>
      <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>{label}</Typography>
      <Box sx={{ 
        border: '2px dashed', 
        borderColor: 'primary.light', 
        borderRadius: 1, 
        bgcolor: '#fff',
        touchAction: 'none',
        position: 'relative'
      }}>
        <SignatureCanvas
          ref={sigRef}
          penColor="#1a237e"
          canvasProps={{
            width: canvasWidth,
            height: 160,
            style: { width: '100%', height: 160, display: 'block' }
          }}
        />
        <Typography 
          variant="caption" 
          color="text.disabled" 
          sx={{ 
            position: 'absolute', 
            bottom: 8, 
            left: '50%', 
            transform: 'translateX(-50%)',
            pointerEvents: 'none',
            userSelect: 'none'
          }}
        >
          Hier unterschreiben
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 1, mt: 0.5 }}>
        <Button size="small" variant="outlined" startIcon={<Clear />} onClick={handleClear}>
          Löschen
        </Button>
        <Button size="small" variant="contained" startIcon={<Check />} onClick={handleConfirm}>
          Bestätigen
        </Button>
      </Box>
    </Box>
  );
};

export default SignaturePad;
